
export default {
  namespaced: true,
  state: {
    profile: '',
    bio: '',
    companyName: '',
    companyDomain: '',
    locationTitle: '',
    locationPlaceId: '',
    category: '',
    companyJobsBoard: [],
    bioError: '',
    companyNameError: null
  },
  getters: {
    formData: state => {
      return {
        profile: state.profile,
        bio: state.bio,
        companyName: state.companyName,
        companyDomain: state.companyDomain,
        category: state.category,
        locationTitle: state.locationTitle,
        locationPlaceId: state.locationPlaceId,
        companyJobsBoard: state.companyJobsBoard
      }
    },
    location: state => ({
      placeId: state.locationPlaceId,
      title: state.locationTitle
    })
  },
  mutations: {
    setProfile (state, profile) {
      state.profile = profile
    },
    setBio (state, bio) {
      if (bio.length > 0) {
        state.bioError = ''
      }
      state.bio = bio
    },
    setCompanyJobsBoard (state, companyJobsBoard) {
      state.companyJobsBoard = companyJobsBoard
    },
    setCompanyName (state, companyName) {
      if (companyName.length > 0) {
        state.companyNameError = null
      }
      state.companyName = companyName
    },
    setCompanyDomain (state, companyDomain) {
      state.companyDomain = companyDomain
    },
    setLocationTitle (state, location) {
      state.locationTitle = location
    },
    setLocationPlaceId (state, placeId) {
      state.locationPlaceId = placeId
    },
    setLocation (state, location) {
      state.locationTitle = location.title
      state.locationPlaceId = location.placeId
    },
    setCategory (state, category) {
      state.category = category
    },
    resetData (state) {
      state.bio = ''
      state.companyName = ''
      state.companyDomain = ''
      state.locationTitle = ''
      state.locationPlaceId = ''
      state.category = ''
      state.companyJobsBoard = []
    },
    setBioError (state, bioError) {
      state.bioError = bioError
    },
    setCompanyNameError (state, companyNameError) {
      state.companyNameError = companyNameError
    }
  },
  actions: {
    loadWithUser ({ commit }, {user, profile}) {
      const bio = user && user.bio ? user.bio : ''
      const companyName = user && user.companyName ? user.companyName : ''
      const companyDomain = user && user.companyDomain ? user.companyDomain : ''
      const locationTitle = user && user.locationTitle ? user.locationTitle : ''
      const locationPlaceId = user && user.locationPlaceId ? user.locationPlaceId : ''
      const category = user && user.companyCategory ? user.companyCategory : ''

      commit('setProfile', profile)
      commit('setBio', bio)
      commit('setCompanyName', companyName)
      commit('setCompanyDomain', companyDomain)
      commit('setLocationTitle', locationTitle)
      commit('setLocationPlaceId', locationPlaceId)
      commit('setCategory', category)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hirer-profile-form.js